<template>
    <RouterView :key="route.fullPath" />
</template>

<script setup>
import { RouterView, useRoute } from 'vue-router';

const route = useRoute();
</script>
